import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CorporateAPIService {
  constructor(private api: ApiService) {}

  public postDonation(asset, donation) {
    return this.api.post(`donate/${asset}`, donation);
  }

  public getCorporate(term) {
    return this.api.get(`lookup/corporate-matching-companies`, {
      q: term,
      page: '1'
    });
  }
}
